import { Card } from "antd";
import { styles } from "../../../Page/Manage/Rooms/Styles";
import { T } from "../../../Page/Styles/css";
import { useEffect, useState } from "react";
import { ENDPOINTS } from "../../../Services/ENDPOINT";

export const StatusBadge = ({ cfg }) => (
    <span style={{
        display: "inline-flex", alignItems: "center", gap: 5,
        fontSize: 11, fontWeight: 600, padding: "4px 10px",
        borderRadius: 20, background: cfg.bg, color: cfg.color,
        border: `1px solid ${cfg.dot}22`,
    }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot }} />
        {cfg.label}
    </span>
);

export const DetailItem = ({ icon, label, value }) => (
    <div style={{
        display: "flex", alignItems: "flex-start", gap: 10,
        padding: "10px 12px", background: T.bg,
        borderRadius: T.radiusSm, border: `1px solid ${T.border}`,
    }}>
        <div style={{
            width: 28, height: 28, borderRadius: 7, background: T.surface,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: T.accent, fontSize: 13, border: `1px solid ${T.border}`,
            flexShrink: 0, marginTop: 1,
        }}>
            {icon}
        </div>
        <div>
            <div style={{ fontSize: 10, color: T.textMuted, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 2 }}>
                {label}
            </div>
            <div style={{ fontSize: 13, color: T.text, fontWeight: 500 }}>{value || "—"}</div>
        </div>
    </div>
);

export const SectionCard = ({ title, icon, children, extra }) => (
    <Card
        style={styles.sectionCard}
        title={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={styles.sectionIcon}>{icon}</span>
                <span>{title}</span>
            </div>
        }
        extra={extra}
        bodyStyle={{ paddingTop: 12 }}
    >
        {children}
    </Card>
);

export function Lightbox({ images, startIndex, onClose }) {
    const [idx, setIdx] = useState(startIndex);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowRight") setIdx((i) => (i + 1) % images.length);
            if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + images.length) % images.length);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [images.length, onClose]);

    const btnStyle = {
        background: "rgba(255,255,255,0.12)", border: "none",
        color: "#fff", cursor: "pointer", borderRadius: "50%",
        display: "flex", alignItems: "center", justifyContent: "center",
    };

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed", inset: 0, zIndex: 1000,
                background: "rgba(0,0,0,0.82)",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}
        >
            {/* Close */}
            <button
                onClick={onClose}
                style={{ ...btnStyle, position: "absolute", top: 16, right: 20, width: 36, height: 36, fontSize: 20 }}
            >
                ✕
            </button>

            {/* Prev */}
            {images.length > 1 && (
                <button
                    onClick={(e) => { e.stopPropagation(); setIdx((i) => (i - 1 + images.length) % images.length); }}
                    style={{ ...btnStyle, position: "absolute", left: 16, width: 44, height: 44, fontSize: 24 }}
                >
                    ‹
                </button>
            )}

            {/* Image */}
            <img
                src={`${ENDPOINTS.cleanBase}/${images[idx]}`}
                alt={`Document ${idx + 1}`}
                onClick={(e) => e.stopPropagation()}
                style={{
                    maxWidth: "88vw", maxHeight: "88vh",
                    borderRadius: 10, objectFit: "contain",
                    boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
                }}
            />

            {/* Next */}
            {images.length > 1 && (
                <button
                    onClick={(e) => { e.stopPropagation(); setIdx((i) => (i + 1) % images.length); }}
                    style={{ ...btnStyle, position: "absolute", right: 16, width: 44, height: 44, fontSize: 24 }}
                >
                    ›
                </button>
            )}

            {/* Counter */}
            {images.length > 1 && (
                <div style={{ position: "absolute", bottom: 20, color: "rgba(255,255,255,0.7)", fontSize: 13 }}>
                    {idx + 1} / {images.length}
                </div>
            )}
        </div>
    );
}


export function parseDocuments(raw) {
    try {
        const arr = JSON.parse(raw || "[]");
        return Array.isArray(arr) ? arr : [];
    } catch {
        return [];
    }
}


export const LogStatusBadge = ({ cfg }) => (
    <span style={{
        display: "inline-flex", alignItems: "center", gap: 5,
        fontSize: 11, fontWeight: 600, padding: "3px 9px",
        borderRadius: 20, background: cfg.bg, color: cfg.text,
    }}>
        <span style={{ width: 5, height: 5, borderRadius: "50%", background: cfg.dot }} />
        {cfg.label}
    </span>
);

export const SectionLabel = ({ children, icon }) => (
    <div style={{
        display: "flex", alignItems: "center", gap: 7,
        fontSize: 10.5, fontWeight: 700, color: T.textSub,
        textTransform: "uppercase", letterSpacing: "0.08em",
        marginBottom: 8,
    }}>
        {icon && <span style={{ color: T.accent, fontSize: 12 }}>{icon}</span>}
        {children}
    </div>
);